import React from 'react';
import Image from '@app/components/Image/Image';
import successIcon from '@app/icons/icon-success.svg';

import styles from '../CoursesItemCard.module.scss';

/**
 * Компонент с информацией, о том, что курс пройден
 */
const PassedCardFooter = () => (
    <div className={styles['passed-block']}>
        Курс пройден
        <Image src={successIcon} alt="" width={20} height={20} />
    </div>
);

export default PassedCardFooter;